<template>
    <div class="archives-module">
        <div class="tab-box">
            <van-tabs sticky id="tabs" line-width="25px" line-height="4px" color="#2FD0D5" title-active-color="#35434C"
                title-inactive-color="#A0ACB5" animated>
                <van-tab title="基本信息">
                    <BaseMsg :baseData="baseData" @onBaseSave="onBaseSave"></BaseMsg>
                </van-tab>
                <van-tab title="皮肤&身体">
                    <body-msg :bodyData="bodyData" :bodyRate="rate" @onBodySave="onBodySave"></body-msg>
                </van-tab>
                <van-tab title="个性化">
                    <special-msg @onSpecialSave="onSpecialSave" :specialData="specialData" :teaOptions="teaOptions"
                        :roomOptions="roomOptions"></special-msg>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request";
import BaseMsg from "./components/baseMsg.vue";
import BodyMsg from "./components/bodyMsg.vue";
import SpecialMsg from "./components/specialMsg.vue";
import { Toast } from 'vant'

import {
    bodyListBeforeHandle,
    bodyListAfterHandle,
    checkCircle,
} from "./components/config.js";

import { timeFormat } from "@/utils";
export default {
    name: "customerArchives",
    components: { BaseMsg, BodyMsg, SpecialMsg },
    data() {
        return {
            rate: null,
            active: 1,
            popupVisible: false,
            custId: "", // id
            baseData: {
                rate: 0,
            }, //基本信息
            bodyData: {}, // 身体皮肤
            specialData: {
                rate: 0,
                fond: '',
                preferential: '',
                teaWaterArray: [],
                roomRateArray: [],
            }, //个性化
            teaOptions: [], //茶水
            roomOptions: [], //房间
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.custId = this.$route.query.custId
            this.getBase();
            this.getBody();
            this.getSpecial();
            this.getSpecialTeaOptions();
            this.getSpecialRoomOptions();
        },
        /**
         * 获取基础信息
         */
        getBase() {
            request({
                url: `/custinfo/info?custId=${this.custId}`,
                method: "get",
            })
                .then((res) => {
                    this.baseData = res.data;
                    this.baseData.birthDate = timeFormat(res.data.birthday);
                })
                .catch(() => {
                    this.baseData = {};
                    Toast({ position: 'top', message: error ?? '' })

                });
        },
        // 保存基础信息修改
        onBaseSave(e) {
            let baseList = e;
            request({
                url: `/custinfo/updateInfo`,
                method: "put",
                data: baseList,
            }).then((res) => {

                this.$toast({
                    message: "保存成功",
                });
                this.init();
            }).catch((error) => {
                Toast({ position: 'top', message: error ?? '' })
            })
        },
        // 保存身体信息修改
        onBodySave(e) {
            let bodyList = e;
            bodyList = bodyListAfterHandle(bodyList);
            bodyList[0].custId = this.custId;
            request({
                url: `/custinfo/updateBody`,
                method: "put",
                data: bodyList,
            }).then((res) => {

                this.$toast({
                    message: "保存成功",
                });
                this.init();
            }).catch((error) => {
                Toast({ position: 'top', message: error ?? '' })
            })
        },
        // 获取身体皮肤信息
        getBody() {
            request({
                url: `/custinfo/body?custId=${this.custId}`,
                method: "get",
            })
                .then((res) => {
                    let bodyList = res.data;
                    bodyList = bodyListBeforeHandle(bodyList);
                    let rate = bodyList[0].rate;
                    const bodyData = checkCircle(res.data);
                    this.bodyData = bodyData;

                    this.rate = rate;
                })
                .catch((error) => {
                    this.bodyData = {};
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        // 保存个性化修改
        onSpecialSave(e) {
            let specialData = e;
            specialData.custId = this.custId
            request({
                url: `/custinfo/updateStyle`,
                method: "put",
                data: specialData,
            }).then((res) => {
                this.$toast({
                    message: "保存成功",
                });
                this.init();
            }).catch((error) => {
                Toast({ position: 'top', message: error ?? '' })
            })
        },
        // 获取个性化
        getSpecial() {
            request({
                url: `/custinfo/style?custId=${this.custId}`,
                method: "get",
            })
                .then((res) => {
                    const { teaWaterArray, roomRateArray, rate, fond, preferential } = res.data;
                    // this.specialData.teaWaterArray = teaWaterArray ?? []
                    // this.specialData.roomRateArray = roomRateArray ?? []
                    // this.specialData.rate = rate ?? 0
                    this.specialData = res.data
                })
                .catch((error) => {
                    this.specialData = {
                        teaWaterArray: [],
                        roomRateArray: [],
                        rate: 0
                    };
                    Toast({ position: 'top', message: error ?? '' })
                });
        },
        // 茶水偏好
        getSpecialTeaOptions() {
            request({
                url: `/dictdata/list?dictType=tea_water`,
                method: "get",
            })
                .then((res) => {
                    this.teaOptions = res.data;
                })
                .catch((error) => {
                    this.teaOptions = [];
                    Toast({ position: 'top', message: error ?? '' })
                });
        },
        // 房间偏好
        getSpecialRoomOptions() {
            request({
                url: `/dictdata/list?dictType=room_rate`,
                method: "get",
            })
                .then((res) => {
                    this.roomOptions = res.data;
                })
                .catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                    this.roomOptions = [];
                });
        },
    },
};
</script>
<style lang="less" scoped>
.mb-106 {
    margin-bottom: 106px;
}

/* ------------ */
.archives-module {
    width: 750px;
    overflow-x: hidden;
    padding: 10px 0;
    box-shadow: inset 0px 2px 10px -11px rgba(0, 0, 0, 1);
    height: 100%;
    overflow-y: auto;
}

.tab-box {
    width: 750px;
}

.popup-show .van-sticky,
.popup-show .van-sticky-wrap,
.popup-show .tabs-index--van-tabs__line {
    z-index: unset !important;
}
</style>
